export function money(value) {    
    return Number(value).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });    
}
